import { render } from "./AutoProfileAI.vue?vue&type=template&id=844f8ef0&scoped=true"
import script from "./AutoProfileAI.vue?vue&type=script&lang=js"
export * from "./AutoProfileAI.vue?vue&type=script&lang=js"

import "./AutoProfileAI.vue?vue&type=style&index=0&id=844f8ef0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-844f8ef0"]])

export default __exports__